"use client";

import { useEffect } from "react";

import { captureMarketingException } from "@/lib/analytics";

type GlobalErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    void captureMarketingException(error, {
      error_boundary: "global",
      digest: error.digest ?? "",
    });
  }, [error]);

  return (
    <html lang="en">
      <body className="font-sans antialiased">
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-4 text-center">
          <h1 className="text-2xl font-semibold tracking-tight text-zinc-900">
            Something went wrong
          </h1>
          <p className="max-w-md text-sm text-zinc-600">
            RivetAI hit an unexpected error. Please try again.
          </p>
          <button
            type="button"
            className="rounded-lg bg-zinc-900 px-4 py-2 text-sm font-medium text-white"
            onClick={reset}
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
